import { render, staticRenderFns } from "./Capital.vue?vue&type=template&id=ed0a42ae&"
import script from "./Capital.vue?vue&type=script&lang=js&"
export * from "./Capital.vue?vue&type=script&lang=js&"
import style0 from "./Capital.vue?vue&type=style&index=0&lang=scss&rel=stylesheet%2Fscss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports